// extracted by mini-css-extract-plugin
module.exports = {"ProjectPage__participants":"ProjectPage_ProjectPage__participants__3NXpM","ProjectPage__participantsTitle":"ProjectPage_ProjectPage__participantsTitle__2TlCg"};